import React from 'react'
import { deleteCategory, deleteProduct, deleteBrand, deleteType, deleteUser,
  deleteEmirate,
  deleteCodeByID,
  deleteDeal,
  deleteBaner,
  deleteCountryByid,
  deleteBlog,
  deleteAuthor,
  deleteBoy
 } from '../../../service/apiService'

const Deletemodal = (props) => {
console.log(props,'pp')
 const handleDelete = async () => {
  if(props.category === 'category'){
  let result = await deleteCategory(props.idtodelete)
  if(result?.status === 200){
    props.closeModal()
    props.initRefresh()
    return
  }
  props.closeModal()
 }

 if(props.proddelete === 'proddelete'){
  let result = await deleteProduct(props.deleteid)
  if(result?.status === 200){
    alert('Product Deleted')
    props.closeModal()
    props.afterProductDelete()
    return
  }
  alert('Product Deletion Failed')
  props.closeModal()
 }

 if(props.brand === 'brand'){
  let result = await deleteBrand(props.idtodelete)
  if(result?.status === 200){
    props.closeModal()
    props.initRefresh()
    return
  }
  props.initRefresh()
 }

 if(props.type === 'type'){
  let result = await deleteType(props.idtodelete)
  if(result?.status === 200){
    props.closeModal()
    props.initRefresh()
    return
  }
  props.initRefresh()
 }

 if(props.user === 'user'){
  let result = await deleteUser(props.deleteid)
  if(result?.status === 200){
    props.closeModal()
    props.afterUserDelete()
    return
  }
  props.closeModal()
 }
 if(props.from === 'deleteemirate'){
  let result = await deleteEmirate(props.idtodelete)
  if(result?.status === 200){
    props.closeModal()
    props.initRefresh()
    return
  }
  props.closeModal()
 }
  if(props.from === 'deletecode'){
  let result = await deleteCodeByID(props.id)
  if(result?.status === 200){
    props.closeModal()
    props.initRefresh()
    return
  }
  props.closeModal()
 } 
if(props.from === 'deletedeal'){
  let result = await deleteDeal(props.id)
  if(result?.status === 200){
    props.closeModal()
    return
  }
  props.closeModal()
 }
if(props.from === 'deletebaner'){
  let result = await deleteBaner(props.id)
  if(result?.status === 200){
    props.initRefresh()
    props.closeModal()
    return
  }
  props.closeModal()
 } 

 if(props.from === 'deletecountry'){
  let result = await deleteCountryByid(props.id)
  if(result?.status === 200){
    props.initRefresh()
    props.closeModal()
    return
  }
  props.closeModal()
 } 
if(props.from === 'deleteblog'){
  let result = await deleteBlog(props.id)
  if(result?.status === 200){
    props.initRefresh()
    props.closeModal()
    return
  }
  props.closeModal()
 } 

if(props.from === 'deleteauthor'){
  let result = await deleteAuthor(props.idtodelete)
  if(result?.status === 200){
    props.closeModal()
    props.initRefresh()
    return
  }
  props.closeModal()
} 

if(props.from === 'deleteboy'){
  let result = await deleteBoy(props.idtodelete)
  if(result?.status === 200){
    props.closeModal()
    props.initRefresh()
    return
  }
  props.closeModal()
} 
 
}

  return (
    <>
    <div className="modal dark-modal profile-edit"  style={{ display: props.isModalOpen ? 'block' : 'none' }} id="logout">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content option-modal bg-curve">
      <div className="modal-body">
        <h2 className="text-uppercase text-center">DELETE</h2>
        <hr className="mb-4" />
        <div className="cm-form">
          <h4 className="text-shade text-center">Are you sure you want to Delete?</h4>
          <hr className="mt-4 mb-4" />
          <div className="d-flex justify-content-between">
           <button data-bs-dismiss="modal" aria-label="Close" className="cancel" onClick={() => {props.closeModal()}}>Cancel</button> 
           <button onClick={handleDelete} className="save ">Yes</button> 
          </div>    
        </div>
      </div>
    </div>
  </div>
</div>
</>
  )
}

export default Deletemodal
